import axios from "./axios";
import * as Sort from "./constants";

export const getStoreBySlug = (slug, index) => {
  return axios.get(`/store/get/slug/${slug}/${index}`);
};

export const getProductsByStoreID = ({ storeID, index }) => {
  let query = `/product/get/store/${storeID}/${index}`;

  return axios.get(query);
};

export const filterProducts = ({
  storeID,
  index,
  sortValue,
  minPrice,
  maxPrice,
  category,
}) => {
  let query = `/product/get/f/${storeID}/${index}`;

  return axios.get(query, {
    params: {
      min: minPrice || 0,
      max: maxPrice || Sort.MAX_PRICE,
      sort: sortValue || Sort.INC_ALPHABET,
      category: category || 0,
    },
  });
};

export const findProducts = ({
  searchString,
  storeID,
  index = 1,
  category,
}) => {
  let query = `product/get/s/${storeID}/${index}`;

  return axios.get(query, {
    params: {
      category: category,
      s: searchString,
    },
  });
};

export const getProductDetail = (productID, storeID) => {
  return axios.get(`product/get/${productID}/${storeID}`);
};

export const getStoreDeliverySetup = (storeID) => {
  return axios.get(`deliverysetup/get/store/${storeID}`);
};

export const applyDiscountCode = (discountCode, storeID) => {
  return axios.get(`discount/get/${discountCode}/${storeID}`);
};

export const makeOrder = ({ order, orderItems, storeSlug, storeID }) => {
  return axios.post(`order/makeorder/${storeID}`, {
    order,
    orderItems,
    storeSlug,
  });
};

export const getOrderFromRef = (paymentRef, gatewayRef, storeID) => {
  return axios.get(`order/verifyOrder/${paymentRef}/${gatewayRef}/${storeID}`);
};